import { sc } from "./reportUtils";

export function Ring({ score, size = 80, stroke = 7, color, dark = false }) {
  const r = 42, circ = 2 * Math.PI * r, fill = (Math.min(score, 100) / 100) * circ;
  const c = color || sc(score);
  return (
    <div style={{ position: "relative", width: size, height: size, flexShrink: 0 }}>
      <svg width={size} height={size} viewBox="0 0 100 100" style={{ transform: "rotate(-90deg)" }}>
        <circle cx="50" cy="50" r={r} fill="none" stroke={dark ? "#374151" : "#E5E7EB"} strokeWidth={stroke} />
        <circle cx="50" cy="50" r={r} fill="none" stroke={c} strokeWidth={stroke}
          strokeLinecap="round" strokeDasharray={`${fill} ${circ}`}
          style={{ transition: "stroke-dasharray 1.2s ease" }} />
      </svg>
      <div style={{ position: "absolute", inset: 0, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <span style={{ fontSize: size * .32, fontWeight: 900, color: dark ? "#fff" : "#111827", lineHeight: 1 }}>{score}</span>
        <span style={{ fontSize: size * .12, color: dark ? "#D1D5DB" : "#4B5563", fontWeight: 700 }}>/100</span>
      </div>
    </div>
  );
}
